module.exports = __webpack_public_path__ + "images/emoji/disappointed_relieved.a410a833c38484d7f790.png";